import { FelaCSS, colors, spacing } from '@bridebook/ui';

interface IStyleProps {
  isMobile: boolean;
}

interface IStyles {
  wrapper: (isVenueProfileV2?: boolean) => FelaCSS;
  infoWrap: (isVenueProfileV2?: boolean) => FelaCSS;
  keyInfoWrap: FelaCSS;
  carouselWrap: FelaCSS;
  mediaButtonSectionWrap: FelaCSS;
  loadingWrap: FelaCSS;
  topBorder: FelaCSS;
  content: (isVenueProfileV2?: boolean) => FelaCSS;
  bottomContent: FelaCSS;
  similarVenuesCarousel: FelaCSS;
  saveToShort: FelaCSS;
  shortlistButtonWrap: FelaCSS;
  breadcrumbs: FelaCSS;
  sectionWrap: (order: number) => FelaCSS;
  navigationBar: FelaCSS;
  budgetMatchLabelWrapper: FelaCSS;
}

const styles = ({ isMobile }: IStyleProps): IStyles => {
  const sidePaddings: FelaCSS = {
    paddingLeft: 4,
    paddingRight: 4,
  };

  return {
    wrapper: (isVenueProfileV2) => ({
      overflowX: 'hidden',
      paddingTop: isVenueProfileV2 ? '25px' : 4,

      maxWidthTabletSm: {
        paddingTop: '0',
      },
    }),

    infoWrap: (isVenueProfileV2) => ({
      maxWidthTabletSm: {
        ...sidePaddings,
        order: 4,
        paddingTop: isVenueProfileV2 ? spacing[5] : spacing[2],
      },
    }),

    keyInfoWrap: {
      borderTop: `1px solid ${colors.space15}`,

      maxWidthTabletSm: {
        ...sidePaddings,
        paddingTop: 2,
        order: 7,
      },
    },

    carouselWrap: {
      position: 'relative',
      maxWidthTabletSm: {
        order: 2,
      },
    },

    mediaButtonSectionWrap: {
      paddingTop: 2,
      paddingBottom: 2,

      maxWidthTabletSm: {
        order: 3,
        paddingTop: '2px',
        paddingBottom: '1px',
      },
    },

    loadingWrap: {
      margin: '95px auto 90px',
    },

    topBorder: isMobile
      ? {
          borderTopStyle: 'solid',
          borderTopColor: colors.grey,
          borderTopWidth: '1px',
        }
      : {},

    content: (isVenueProfileV2) => ({
      order: 8,
      paddingTop: 4,

      ...(isVenueProfileV2 && { paddingTop: 0 }),

      maxWidthTabletSm: {
        paddingTop: 0,
      },
    }),

    bottomContent: {
      order: 9,
    },

    similarVenuesCarousel: {
      order: 10,
    },

    saveToShort: {
      top: spacing[4],
      right: spacing[4],
      desktopDesign: {
        top: spacing[2],
        right: spacing[2],
      },
    },

    shortlistButtonWrap: {
      position: 'absolute',
      zIndex: 4,
      top: spacing[4],
      right: spacing[4],
      flexDirection: 'row',
      gap: spacing[4],

      maxWidthTabletSm: {
        order: 1,
      },
    },
    breadcrumbs: {
      paddingTop: 4,
      margin: 0,
    },
    navigationBar: {
      minWidthTabletLg: {
        paddingTop: 4,
      },
    },
    sectionWrap: (order: number) => ({
      order,
      maxWidthTabletSm: {
        order,
      },
    }),
    budgetMatchLabelWrapper: {
      // to be vertically aligned
      // with favourite button
      marginTop: spacing[2],
    },
  };
};

export default styles;
